import ActionsForm from '@/shared/mixins/actionsForm'
import qmaTemplate from '@/shared/http/repositories/business/qmaTemplate'
import newTemplate from '@/views/private/qma/qmaTemplate/newTemplate/newTemplate.vue'
import deleteTemplate from '@/views/private/qma/qmaTemplate/deleteTemplate/deleteTemplate.vue'
import { toast, loading } from '@/shared/utils/UIHelper'

export default {
  name: 'templateTable',
  mixins: [ActionsForm],
  components: {newTemplate, deleteTemplate},
  data () {
    return {
      columTemplate: ['ITEM AVALIAÇÃO', 'CÓDIGO DO PIVS', 'STATUS', 'DT. DE CRIAÇÃO', 'REVISÃO', ''],
      formSearch: {},
      dataTemplatePIVS: [],
      tipoFluxo: 'PIVS',
      codigo: null,
      pes: null,
      id: null,
      template: null
    }
  },

  mounted () {
    this.onLoad()
  },
  methods: {
    desativarAtivar (id) {
      qmaTemplate.inativaAtivaQMATemplate(id)
        .then((Response) => {
          loading.pop()
          this.onLoad()
        }).catch(Error => {
          loading.pop()
          toast.warning('Não foi possível alterar o status')
        })
    },
    onLoad () {
      loading.push()
      this.formSearch.FluxoTemplate = 2
      qmaTemplate.GetQMATemplateParaTodosTemplatesGrid(this.$refs.tableGridsTemplateQMAPivs.pagingLimit, this.$refs.tableGridsTemplateQMAPivs.pagingIndex, this.formSearch)
        .then((Response) => {
          loading.pop()
          this.$refs.tableGridsTemplateQMAPivs.LoadAllByData(Response)
          this.dataTemplatePIVS = Response.data.data
        }).catch(Error => {
          loading.pop()
          toast.warning('dados não encontrado')
        })
    },
    openFiles () {
      document.getElementById('impor-ex-price').click()
    },
    imporTable (e) {
      if (e.target.files.length === 0) return
      let conf = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      let data = new FormData()
      data.append('Excel', e.target.files[0])
      loading.push()
      qmaTemplate.ImportableByQMAPIVS(data, conf)
        .then(Response => {
          toast.success('Excel importado com sucesso!!', 'Excel')
          this.onLoad()
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
          toast.warning('Formato invalido!!', 'Excel')
        })
    },
    DetailsExpense (value) {
      this.$emit('templateQMADetalhes', value)
    },
    abrirPopUp () {
      this.$refs.newtablepivs.popUptAdd()
    },
    abrirPopUpEditar (dadosTemplate) {
      this.$refs.newtablepivs.popUptEdicao(dadosTemplate)
    },
    excluirTemplate (dadosTemplate) {
      this.id = dadosTemplate.id
      this.template = dadosTemplate.itemAvaliacao
      this.$refs.deletetablepivs.popUptExlusao()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/qma/qmaTemplate/templateQmaPIVS/components/templateTable/templateTable.js